var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-24"},[_c('mail'),_vm._v(" "),_c('internal-task-activities')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 pr-24"},[_c('task-template-manager'),_vm._v(" "),_c('tags'),_vm._v(" "),_c('services')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d10ecf26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/config/Index.vue
// module id = null
// module chunks = 